<div class="container">
    <div  class="member-form"> 
        <div style="text-align: center; padding: 4px;" (click)="goHome()">
            <img width="88" alt="Zulu logo" src="/assets/images/logo.jpg" />
          </div>
      
      <div class="content">
        <div class="card-container" style="max-width: 540px; background-color: white;">
            <h1>Thank you!</h1>
        </div>
      </div>
    </div>
  </div>